import { Box } from "arkh";
import React from "react";
import { View } from "react-native";

export const ResultGrid = React.memo(ResultGridC) as typeof ResultGridC;

function ResultGridC<T>({
  items,
  rows = 4,
  renderRow,
  keyExtractor,
}: {
  items: T[];
  rows?: number;
  renderRow: (item: T) => React.ReactNode;
  keyExtractor: (item: T, index: number) => string;
}) {
  const columns =
    items.length <= rows
      ? [items.slice(0, rows / 2), items.slice(rows / 2)]
      : items.length > rows
        ? [items.slice(0, rows), items.slice(rows)]
        : [items.slice(0, rows)];
  return (
    <Box
      spaceBottom="small"
      spaceRight="small"
      style={{ flex: 1, flexDirection: "row", height: "100%" }}
    >
      {columns.map((_rows, columnIndex) => (
        <View
          key={columnIndex + ""}
          style={{
            flex: 1,
            justifyContent: "flex-start",
            position: "relative",
            height: "100%",
          }}
        >
          {_rows.map((routine, rowIndex) => (
            <Box
              space="xsmall"
              key={keyExtractor(routine, columnIndex * rows + rowIndex)}
              style={{
                overflow: "hidden",
                width: "100%",
                flex: 1,
                maxHeight: "25%",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {renderRow(routine)}
            </Box>
          ))}
        </View>
      ))}
    </Box>
  );
}
